import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { dataMetaSelector, deleteStage } from "Venues/state";
import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";
import { VENUE_ACTIONS } from "Venues/types";
import { IAPIState, IStatus } from "shared/types";
import { useVenuePageContext } from "Venues/contexts";
import { addTemporaryToast } from "shared/components/Toast";
import { VENUE_PATHS } from "Venues/router";
import { useHistory } from "react-router-dom";
import { useClearActionMetaOnUnMount, useVenueRoute } from "Venues/utils";

interface DeleteStageModalProps {
  stageId?: string;
  handleClose: () => void;
}

export const DeleteStageModal: React.FC<DeleteStageModalProps> = ({
  stageId,
  handleClose,
}) => {
  const { getPath } = useVenueRoute();
  const { venueStages } = useVenuePageContext();

  const history = useHistory();
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(VENUE_ACTIONS.deleteStage)
  );
  useClearActionMetaOnUnMount(VENUE_ACTIONS.deleteStage);

  const title = useMemo(() => {
    if (stageId) {
      return venueStages?.find(({ id }) => id === stageId)?.title || "";
    }
    return "";
  }, [stageId, venueStages]);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: copy.deleteStage.success,
        })
      );
      history.push(getPath(VENUE_PATHS.VENUE));
      handleClose();
    }
  }, [apiMeta, dispatch, handleClose, history, getPath]);

  const handleDelete = () => {
    if (stageId) {
      dispatch(deleteStage(stageId));
    }
  };

  return (
    <DeleteModal
      type={copy.stageProperties.stage.title}
      name={title}
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};
